import { useEffect, useState } from 'react';
import { getEpisodeStatus } from '../helpers/schedule-helper';
import { EPISODE_STATUSES, TYPE_OFFLINE } from '../constants/common';

/**
 * 
 * @param {object} episode 
 * @returns {boolean}
 */
export function useAvaliableWidgetRecord(episode) {
    if (!episode) return false;

    const [isReconrdAvaliable, setRecordAvaliable] = useState(false);

    useEffect(() => {
        const isWidget = window.self !== window.top;
        const isEpisodePast = getEpisodeStatus(episode) === EPISODE_STATUSES.record;

        setRecordAvaliable(isWidget && isEpisodePast);
    }, [episode]);

    return isReconrdAvaliable;
}
